import { __decorate } from "tslib";
import { AsnPropTypes, AsnProp } from "@peculiar/asn1-schema";
import { Version } from "./version";
export const id_adbe_archiveRevInfo = "1.2.840.113583.1.1.9.2";
export class ArchiveRevInfo {
    constructor(params = {}) {
        this.version = Version.v1;
        Object.assign(this, params);
    }
}
__decorate([
    AsnProp({ type: AsnPropTypes.Integer })
], ArchiveRevInfo.prototype, "version", void 0);
